/**
 * HTML エレメントがフォーカスされた時に画面外ならスクロールする Svelte Action
 *  @see https://svelte.dev/docs/svelte-action
 *  iOS で required な入力要素が入力されてない時に Submit されても、画面内にスクロールしようとしないバグへの対策
 *   @see https://qiita.com/bananacoffee/items/523449897c0b6c4c8a10
 * @param {object} node
 */
export const scrollOnFocus = node => {
  const listener = () => {
    setTimeout(() => {
      // ちょっと待ってから、画面外の場合のみスクロールする
      const rect = node.getBoundingClientRect()
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        node.scrollIntoView()
      }
    }, 100)
  }

  node.addEventListener('focus', listener)

  return {
    destroy() {
      // アンマウント時に remove listener しておく
      node.removeEventListener('focus', listener)
    },
  }
}

export default scrollOnFocus
